import { theme } from '@frameio/vapor-theme';
import { FOLDER_COLOR_HEX, type FolderColorKey } from './folderColorPalette';
import TEXT from './generated/TEXT/folderColors';

export * from './folderColorPalette';

export const FOLDER_COLOR_OPTIONS: {
  key: FolderColorKey;
  hex: string;
  token: string;
  textToken: string;
  label: string;
}[] = [
  {
    key: 'red',
    hex: FOLDER_COLOR_HEX.red,
    token: theme.colors.meta.opaque.red,
    textToken: theme.colors.meta.text.red,
    get label() {
      return TEXT.red;
    },
  },
  {
    key: 'orange',
    hex: FOLDER_COLOR_HEX.orange,
    token: theme.colors.meta.opaque.orange,
    textToken: theme.colors.meta.text.orange,
    get label() {
      return TEXT.orange;
    },
  },
  {
    key: 'yellow',
    hex: FOLDER_COLOR_HEX.yellow,
    token: theme.colors.meta.opaque.yellow,
    textToken: theme.colors.meta.text.yellow,
    get label() {
      return TEXT.yellow;
    },
  },
  {
    key: 'green',
    hex: FOLDER_COLOR_HEX.green,
    token: theme.colors.meta.opaque.green,
    textToken: theme.colors.meta.text.green,
    get label() {
      return TEXT.green;
    },
  },
  {
    key: 'blue',
    hex: FOLDER_COLOR_HEX.blue,
    token: theme.colors.meta.opaque.blue,
    textToken: theme.colors.meta.text.blue,
    get label() {
      return TEXT.blue;
    },
  },
  {
    key: 'purple',
    hex: FOLDER_COLOR_HEX.purple,
    token: theme.colors.meta.opaque.purple,
    textToken: theme.colors.meta.text.purple,
    get label() {
      return TEXT.purple;
    },
  },
];

export const DEFAULT_FOLDER_COLOR =
  theme.colors.components.folder.header.background;

export function getFolderColorMix(
  token: string,
  isLight: boolean,
  percentage: number = isLight ? 80 : 50
): string {
  return isLight
    ? `color-mix(in srgb, ${token} ${percentage}%, white)`
    : `color-mix(in srgb, ${token} ${percentage}%, black)`;
}

TEXT.DEFINE({
  /** Label for the red folder color option */
  red: 'Red',
  /** Label for the orange folder color option */
  orange: 'Orange',
  /** Label for the yellow folder color option */
  yellow: 'Yellow',
  /** Label for the green folder color option */
  green: 'Green',
  /** Label for the blue folder color option */
  blue: 'Blue',
  /** Label for the purple folder color option */
  purple: 'Purple',
});
